import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function AtsExportDialog({
  provider,
  onClose,
  form,
  setForm,
  pushing,
  result,
  onSubmit,
  topN,
}) {
  return (
    <Dialog open={Boolean(provider)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="ats-push-modal" className="max-w-lg">
        <DialogHeader>
          <DialogTitle>
            Push top {topN} to {provider === "greenhouse" ? "Greenhouse" : "Lever"}
          </DialogTitle>
          <DialogDescription>
            We'll send each candidate's name, email, and Hireloop PRO score to
            your ATS using your own API key. Keys are sent over HTTPS and not
            stored.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              API key
            </Label>
            <Input
              data-testid="ats-api-key-input"
              type="password"
              value={form.api_key}
              onChange={(e) => setForm({ ...form, api_key: e.target.value })}
              className="mt-2 rounded-sm border-slate-300"
            />
          </div>
          {provider === "greenhouse" && (
            <div>
              <Label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                On-Behalf-Of user ID
              </Label>
              <Input
                data-testid="ats-on-behalf-of-input"
                value={form.on_behalf_of}
                onChange={(e) =>
                  setForm({ ...form, on_behalf_of: e.target.value })
                }
                placeholder="Greenhouse user id"
                className="mt-2 rounded-sm border-slate-300"
              />
            </div>
          )}
          {provider === "lever" && (
            <div>
              <Label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                Perform-as user ID
              </Label>
              <Input
                data-testid="ats-perform-as-input"
                value={form.perform_as}
                onChange={(e) =>
                  setForm({ ...form, perform_as: e.target.value })
                }
                placeholder="Lever user id"
                className="mt-2 rounded-sm border-slate-300"
              />
            </div>
          )}

          {result && (
            <div
              data-testid="ats-result"
              className="border border-slate-200 bg-slate-50 p-3 text-sm"
            >
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center gap-1 text-emerald-700">
                  <CheckCircle2 className="h-4 w-4" />
                  {result.pushed.length} pushed
                </span>
                <span className="inline-flex items-center gap-1 text-red-600">
                  <XCircle className="h-4 w-4" />
                  {result.failed.length} failed
                </span>
              </div>
              {result.failed.length > 0 && (
                <ul className="mt-3 space-y-1 text-xs text-slate-600">
                  {result.failed.map((f, k) => (
                    <li key={k}>
                      · <strong>{f.name || "—"}</strong>: {f.reason}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm">
            Close
          </Button>
          <Button
            data-testid="ats-push-submit-btn"
            onClick={onSubmit}
            disabled={pushing || !form.api_key.trim()}
            className="rounded-sm bg-blue-700 hover:bg-blue-600"
          >
            {pushing && <Loader2 className="mr-2 h-3 w-3 animate-spin" />}
            Push top {topN}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
